// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip--9b824a74"};